import React from "react";
import { Modal, Button } from "antd";
import { DeleteOutlined, CloseOutlined } from "@ant-design/icons";

export type CategoryDeletedModalProps = {
  open: boolean;
  onClose: () => void;
};

export const CategoryDeletedModal: React.FC<CategoryDeletedModalProps> = ({
  open,
  onClose,
}) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={520}
      destroyOnClose
      className="category-deleted-modal modal-round"
      closeIcon={<CloseOutlined className="category-deleted-close-icon" />}
    >
      <div className="category-deleted-hero">
        <div className="category-deleted-hero-shapes" />
        <div className="category-deleted-hero-icon">
          <DeleteOutlined />
        </div>
      </div>

      <div className="category-deleted-content">
        <div className="category-deleted-title">Category Deleted</div>
        <div className="category-deleted-subtitle">
          The category has been removed successfully.
        </div>

        <Button
          type="primary"
          danger
          size="large"
          className="category-deleted-btn"
          onClick={onClose}
        >
          OK
        </Button>
      </div>
    </Modal>
  );
};

export default CategoryDeletedModal;
